<script lang="ts">
	export let title: string;
</script>

<div class="grid gap-2">
	<div class="text-sm text-primary text-bold">
		{title}
	</div>
	<slot />
</div>
